module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-9c8e9b96!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/other/blank.vue
// module id = 777
// module chunks = 1